import * as Yup from "yup";

export function WorktimeValidationSchema() {
  const validation = Yup.object({
    day: Yup.string().optional(),
    start_time: Yup.string().optional(),
    end_time: Yup.string().optional(),
    start_interval: Yup.string().optional(),
    end_interval: Yup.string().optional(),
  });

  return validation;
}
